import React, { Component } from 'react';

import ImageUploadComponent from './image-upload.component'

class ImageUpload extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            images : []
        }
    }

    onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        this.setState({ 
            images : imageList
        });       
      };

    render() {
        return <ImageUploadComponent 
            {...{
                images: this.state.images
            }}
            onChange = {this.onChange}
        />;
    }
}

export default ImageUpload;
